import { isPC } from '@/utils'
export default {
  YesOrNo: [
    { value: 0, label: '否' },
    { value: 1, label: '是' }
  ],
  platformMap: {},
  departmentType: [
    { value: 1, label: '市场' },
    { value: 2, label: '运营' },
    { value: 3, label: '设计' }
  ],
  // 媒体类型
  TOUTIAO: 1,
  TENCENT: 2,
  KUAISHOU: 3,
  BAIDU: 4,
  MP: 5,
  UC: 6,
  IQIYI: 10,
  BAIDU_SEARCH: 14,
  SHENMA_SEARCH: 16,
  DOUYIN_STAR: 21,
  TOUTIAO_APP: 23,
  QIHU_SEARCH: 24, // 360 又名奇虎
  HUYA: 29,
  WEIBO: 85,
  TOUTIAO_PINPAI: 108,
  BILIBILI: 163,
  JN_PUSH: 168,
  ASA: 184,
  FACEBOOK: 181,
  QIHU_JINGJIA: 210,
  QIHU_SHOW: 312,
  XINGTU: 221,
  YOUTUBE: 243,
  ZHIHU: 245,
  ZHIHU_XINXILIU: 403,
  MINTEGRAL: 250,
  NETEASE_YOUDAO: 239,
  KUAI_KAN: 257,
  ALIPAY: 260,
  XIAOHONGSHU: 253,
  YITUO: 322,
  DIANJING: 323,
  YOUKU: 59,
  JUGUANG: 291,
  ORGANIC: 265,
  GOOGLE_ADWORDS: 186,
  OW: 8,
  APPIER: 267,
  AUDO: 264,
  SOYBEANMOB: 275,
  HUAWEI: 177,
  HUAWEI_JINGHONG: 311,
  TAPTAP: 195,
  YY: 361,
  media: [{
    value: 1,
    label: '今日头条'
  }, {
    value: 2,
    label: '广点通'
  }, {
    value: 3,
    label: '快手'
  }, {
    value: 4,
    label: '百度'
  }, {
    value: 5,
    label: '微信'
  }, {
    value: 6,
    label: 'UC汇川'
  }, {
    value: 10,
    label: '爱奇艺'
  }, {
    value: 14,
    label: '百度搜索'
  }, {
    value: 16,
    label: '神马搜索'
  }, {
    value: 23,
    label: '头条应用管理中心'
  }, {
    value: 24,
    label: '360搜索'
  }, {
    value: 29,
    label: '虎牙'
  }, {
    value: 49,
    label: '喜马拉雅'
  }, {
    value: 85,
    label: '微博'
  }, {
    value: 163,
    label: '哔哩哔哩'
  }, {
    value: 168,
    label: '锦囊智推'
  }, {
    value: 184,
    label: 'ASA'
  }, {
    value: 181,
    label: 'Facebook'
  }, {
    value: 210,
    label: '360竞价'
  }, {
    value: 312,
    label: '360展示'
  }, {
    value: 221,
    label: '星图'
  }, {
    value: 243,
    label: 'Youtube'
  }, {
    value: 245,
    label: '知+'
  }, {
    value: 403,
    label: '知乎信息流'
  }, {
    value: 250,
    label: 'Mintegral'
  }, {
    value: 239,
    label: '网易有道'
  }, {
    value: 257,
    label: '快看'
  }, {
    value: 260,
    label: '支付宝'
  }, {
    value: 253,
    label: '小红书'
  }, {
    value: 322,
    label: '易拓'
  }, {
    value: 323,
    label: '360点睛'
  }, {
    value: 59,
    label: '优酷'
  }, {
    value: 291,
    label: '聚光'
  }, {
    value: 265,
    label: 'organic'
  }, {
    value: 186,
    label: 'google_adwords'
  }, {
    value: 8,
    label: '官网'
  }, {
    value: 267,
    label: 'appier'
  }, {
    value: 264,
    label: 'audo'
  }, {
    value: 275,
    label: 'Soybeanmob'
  }, {
    value: 177,
    label: '华为'
  }, {
    value: 311,
    label: '华为鲸鸿动能'
  }, {
    value: 195,
    label: 'taptap'
  }, {
    value: 240,
    label: 'Espaceads'
  }, {
    value: 361,
    label: 'YY语音'
  }, {
    value: 9,
    label: '其他'
  }, {
    value: 21,
    label: '抖音红人'
  }, {
    value: 30,
    label: '快接单'
  }, {
    value: 61,
    label: '品宣'
  }, {
    value: 62,
    label: '搜索品专'
  }, {
    value: 164,
    label: '快手品牌'
  }, {
    value: 204,
    label: '芈兔兔'
  }, {
    value: 241,
    label: '自建广告变现'
  }, {
    value: 200,
    label: '微视'
  }, {
    value: 252,
    label: '私域'
  }, {
    value: 300,
    label: '豆瓣'
  }],
  platIdMap: [{
    value: 1,
    label: '页游'
  }, {
    value: 2,
    label: '手游'
  }, {
    value: 3,
    label: 'H5'
  }, {
    value: 7,
    label: '微信小游戏'
  }, {
    value: 8,
    label: 'PC端游'
  }, {
    value: 9,
    label: '快游戏'
  }, {
    value: 10,
    label: '抖音小游戏'
  }],
  authMediaTypeList: [1, 3, 4, 5, 6, 10, 14, 16, 85, 163, 181, 184, 210, 243, 177],
  isPC: isPC(),
  domain: 'https://dms.zeda.cn',
  downloadDomain: 'https://download.zeda.cn/',
  majordomoMedia() {
    return [
      this.MP
    ]
  },
  /**
   * @param  {Array} mediaTypes
   * @return {Array}
   */
  mediaOptions(mediaTypes = []) {
    return this.media.filter(item => mediaTypes.indexOf(item.value) !== -1)
  },
  modules: [
    { value: 'DMS', name: '数据中心' },
    { value: 'DSP', name: '投放中心' },
    { value: 'ERP', name: '进销存中心' },
    { value: 'LY', name: '发行中心' },
    { value: 'FA', name: '人事管理' },
    { value: 'AI', name: 'AI中心' }
  ]
}
